// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eucY","question":"styles_question__1D2Vm","description":"styles_description__2dTw6"};